"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevel3Details = void 0;
const country_1 = require("../enums/country");
const getLevel3Details = (country, { amount_details, payment_details, }) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return { amount_details, payment_details };
    }
    return undefined;
};
exports.getLevel3Details = getLevel3Details;
